"use client"

import { useState, useEffect } from "react"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { motion } from "framer-motion"
import { Home, Grid3X3, Package, MessageCircle, User } from "lucide-react"

const navItems = [
  { name: "Home", href: "/", icon: Home },
  { name: "Categories", href: "/categories", icon: Grid3X3 },
  { name: "Products", href: "/products", icon: Package },
  { name: "Contact", href: "/contact", icon: MessageCircle },
  { name: "About", href: "/about", icon: User },
]

export default function MobileBottomNav() {
  const [isMobile, setIsMobile] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }
    checkMobile()
    window.addEventListener("resize", checkMobile)
    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  if (!isMobile) return null

  return (
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-t border-slate-200/50 px-2 py-2"
    >
      <div className="flex items-center justify-around">
        {navItems.map((item) => {
          const isActive = pathname === item.href
          return (
            <Link key={item.name} href={item.href} className="flex-1">
              <motion.div
                className={`flex flex-col items-center py-2 px-3 rounded-xl transition-colors ${
                  isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:text-slate-900"
                }`}
                whileTap={{ scale: 0.95 }}
              >
                <item.icon className="h-5 w-5 mb-1" />
                <span className="text-xs font-medium">{item.name}</span>
              </motion.div>
            </Link>
          )
        })}
      </div>
    </motion.div>
  )
}
